import { API_IMAGE_URL } from "../Url/Url";

export const DEFAULT_COMPANY_LOGO =
  "/jobPortal/assets/images/dashboard/images1.png";

export const DEFAULT_JOB_COVER =
  "/jobPortal/assets/images/job/job-img-6.jpg";

export const resolveCompanyLogoUrl = (logo) => {
  if (!logo) return DEFAULT_COMPANY_LOGO;

  if (logo === DEFAULT_COMPANY_LOGO) {
    return logo;
  }

  if (logo.includes("uploads/https")) {
    return logo.substring(logo.indexOf("https"));
  }

  if (logo.startsWith("http://") || logo.startsWith("https://")) {
    return logo;
  }

  if (logo.startsWith("/jobPortal/")) {
    return logo;
  }

  return `${API_IMAGE_URL}${logo}`;
};

export const handleCompanyLogoError = (event) => {
  event.currentTarget.onerror = null;
  event.currentTarget.src = DEFAULT_COMPANY_LOGO;
};

export const handleJobCoverError = (event) => {
  event.currentTarget.onerror = null;
  event.currentTarget.src = DEFAULT_JOB_COVER;
};
